"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelperText = void 0;
var estiloHelperText = require('./HelperText.module.scss');
var react_1 = __importStar(require("react"));
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Cores_1 = require("../Cores/Cores");
var Icone_1 = require("../Icone/Icone");
var HelperText = function (_a) {
    var _b = _a.texto, texto = _b === void 0 ? 'Texto de ajuda' : _b, icone = _a.icone, _c = _a.estado, estado = _c === void 0 ? 'regular' : _c, desabilitado = _a.desabilitado;
    var _d = react_1.default.useState(Cores_1.Cores.TextoPadrao.CinzaMU600), cor = _d[0], setCor = _d[1];
    (0, react_1.useEffect)(function () {
        if (desabilitado) {
            setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU400);
        }
        else {
            if (estado === 'regular') {
                setCor(Cores_1.Cores.TextoPadrao.CinzaMU600);
            }
            else if (estado === 'error') {
                setCor(Cores_1.Cores.MensagensDoSistema.VermelhoMU);
            }
            else if (estado === 'success') {
                setCor(Cores_1.Cores.MensagensDoSistema.VerdeMU);
            }
        }
    }, [estado, desabilitado]);
    return (react_1.default.createElement("label", { className: "".concat(estiloHelperText.container, " ").concat(desabilitado ? estiloHelperText.desabilitado : '') },
        icone && react_1.default.createElement(Icone_1.Icone, { nome: icone, cor: cor }),
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "caption", cor: cor }, texto)));
};
exports.HelperText = HelperText;
